import { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import { Line } from "react-chartjs-2";
// Constants - Functions
import { colorsArray } from "../../../../config/constants";
// Components
import Graphic from "../../../graphic";
import GraphicContainer from "../../../GraphicContainer";
import GameModeLegend from "../gameModeLegend";

const DifficultyModulatorsPlot = forwardRef(({ recordings, targetedDifficultyModulators, protocolPrefix }, ref) => {
  const [t] = useTranslation("global");

  const difficultyModulatorsData = () => {
    let difficultyModulatorsValues = [];
    let gameModes = [];
    let sessionsId = [];
    let currentColorIndex = 0;
    // Set each session and game mode
    targetedDifficultyModulators.forEach((dm) => {
      if (!gameModes.includes(dm.GAME_MODE)) gameModes.push(dm.GAME_MODE);
      if (!sessionsId.includes(dm.SESSION_ID)) sessionsId.push(dm.SESSION_ID);
      dm.PARAMETER_VALUE = Number(dm.PARAMETER_VALUE);
    });
    // Running each game mode
    gameModes.forEach((gameMode) => {
      let gameModeBySession = [];
      // Running each session
      sessionsId.forEach((sessionId) => {
        let currentDifficultyModulators = [];
        let currentDifficultyModulatorsValues = [];
        // Get a reverse array because is required only the last difficulty modulators of each game mode
        const dmByGameMode = targetedDifficultyModulators
          .filter((dm) => dm.GAME_MODE === gameMode && dm.SESSION_ID === sessionId)
          .reverse();
        dmByGameMode.forEach((dm) => {
          if (!currentDifficultyModulators.includes(dm.PARAMETER_KEY)) {
            currentDifficultyModulators.push(dm.PARAMETER_KEY);
            currentDifficultyModulatorsValues.push(dm.PARAMETER_VALUE);
          }
        });
        // Getting difficulty modulators average
        let dmAverage = 0;
        currentDifficultyModulatorsValues.forEach((value) => {
          dmAverage += value;
        });
        dmAverage /= currentDifficultyModulatorsValues.length;
        gameModeBySession.push(dmAverage);
      });
      // Filling all sessions
      let totalSessionsId = [];
      recordings.forEach((recording) => {
        if (!totalSessionsId.includes(recording.SESSION_ID)) {
          totalSessionsId.push(recording.SESSION_ID);
          if (gameModeBySession.length < totalSessionsId.length) {
            gameModeBySession.unshift(NaN);
          }
        }
      });
      // Pushing each game mode input
      difficultyModulatorsValues.push({
        label: gameMode,
        data: gameModeBySession,
        backgroundColor: [colorsArray[currentColorIndex]],
        borderColor: [colorsArray[currentColorIndex]],
        spanGaps: true,
      });
      // Setting next index color
      currentColorIndex === colorsArray.length - 1 ? (currentColorIndex = 0) : currentColorIndex++;
    });

    return {
      labels: recordings.map((_, i) => i + 1),
      datasets: difficultyModulatorsValues,
    };
  };

  const chartData = difficultyModulatorsData();

  return (
    <GraphicContainer ref={ref} height="auto">
      <Graphic
        Title={t("difficultyModulators")}
        Type={Line}
        data={chartData}
        axisY={t("difficultyLevel")}
        axisX={t("sessions")}
        max={1}
        forceHideLegend
        graphicDescription={t("graphics_difficultyModulatorsDescription_App_protocol")}
        legend={<GameModeLegend datasets={chartData.datasets} protocolPrefix={protocolPrefix} tooltipId="dmLegendTip" />}
      />
    </GraphicContainer>
  );
});

export default DifficultyModulatorsPlot;
